import { ChakraProvider, theme } from "@chakra-ui/react";
import * as React from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import PrivacyPolicy from "./pages/privacy-policy/PrivacyPolicy";
import TermsOfUse from "./pages/terms-of-use/TermsOfUse";
import { detectBrowserLang } from "./lib/lang";

// Root auto-selects a language from the browser (URL always wins elsewhere).
const RootRedirect = () => (
  <Redirect to={detectBrowserLang() === "en" ? "/en/terms" : "/terms"} />
);

export const App = () => (
  <ChakraProvider theme={theme}>
    <Router>
      <Switch>
        <Route path="/en/privacy" component={PrivacyPolicy} />
        <Route path="/en/terms" component={TermsOfUse} />
        <Route exact path="/en" render={() => <Redirect to="/en/terms" />} />
        <Route path="/privacy" component={PrivacyPolicy} />
        <Route path="/terms" component={TermsOfUse} />
        <Route exact path="/" component={RootRedirect} />
        {/* Unknown routes fall back to the default page. */}
        <Route render={() => <Redirect to="/terms" />} />
      </Switch>
    </Router>
  </ChakraProvider>
);
